import React, { useState } from "react";
import { Layout, Menu } from "antd";
import {
  SwapOutlined,
  BankOutlined,
  SettingOutlined,
  DatabaseOutlined,
  ToolOutlined,
  TeamOutlined,
  FileOutlined,
  BarChartOutlined,
  ClockCircleOutlined
} from "@ant-design/icons";
import classes from "./SiderContent.module.css";

const { Sider } = Layout;

const SiderContent = () => {
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    {
      key: "1",
      icon: <SwapOutlined />,
      label: "Stock Transfer"
    },
    {
      key: "2",
      icon: <BankOutlined />,
      label: "Accounts"
    },
    {
      key: "3",
      icon: <BarChartOutlined />,
      label: "Production"
    },
    {
      key: "4",
      icon: <ToolOutlined />,
      label: "Machine Breakdown"
    },
    {
      key: "5",
      icon: <TeamOutlined />,
      label: "HR Payroll"
    },
    {
      key: "6",
      icon: <ClockCircleOutlined />,
      label: "PDC"
    },
    {
      key: "7",
      icon: <FileOutlined />,
      label: "Reports"
    },
    {
      key: "8",
      icon: <SettingOutlined />,
      label: "Setting"
    },
    {
      key: "9",
      icon: <DatabaseOutlined />,
      label: "Database Backup"
    }
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      className={classes.sider}
    >
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={["1"]}
        className={classes.menu}
        items={menuItems}
      />
    </Sider>
  );
};

export default SiderContent;
